export default {
  version: 'master',
  compilation: '294178'
}



//////////////////
// WEBPACK FOOTER
// ./version.js
// module id = 1478
// module chunks = 22